// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../CommunityWebPortal/_app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".charactercount[data-v-08b86b68]{font-size:10px}.errorfont[data-v-08b86b68]{color:red}.state_spacer[data-v-08b86b68]{min-height:20px}", ""]);
// Exports
module.exports = exports;
